<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <div class="loader_div_GMJ" *ngIf="loader">
        <span class="loader_GMJ"></span>
      </div>
      <form [formGroup]="form" class="fd" (ngSubmit)="onFormSubmit()">
        <input type="hidden" formControlName="currency">
        <!-- <div class="fd rds_5 m_tb_15 shadow_1"> -->
        <div class="fd rds_5 bg_7">
          <div class="row payKsamaInp">



            <div class="col-sm-12">
              <!-- From Date -->
              <div class="df_flex-col date-picker-cls">
                <label>{{'FROM_DATE' | translate}}*</label>
                <input type="date" formControlName="startDate" [max]="endDate || todaydate" class="custom-date"
                  [ngModel]="startDate ? (startDate | date:'yyyy-MM-dd') : ''" (ngModelChange)="startDate = $event"
                  required>
              </div>
              <small class="error fielderror" *ngIf="form.get('startDate')?.errors && form.get('startDate')?.touched">
                <span *ngIf="form.get('startDate')?.errors?.['required']">
                  {{ 'SELECT_START_DATE' | translate }}
                </span>

                <span *ngIf="form.get('startDate')?.errors?.['max']">
                  {{ 'START_DATE_AFTER_END' | translate }}
                </span>
              </small>
            </div>

            <!-- To Date -->
            <div class="col-sm-12">
              <div class="df_flex-col date-picker-cls ">
                <label>{{'TO_DATE' | translate}}*</label>

                <input type="date" formControlName="endDate" [min]="startDate" [max]="todaydate" class="custom-date"
                  [ngModel]="endDate ? (endDate | date:'yyyy-MM-dd') : ''" (ngModelChange)="endDate = $event" required>
              </div>
              <small class="error fielderror" *ngIf="form.get('endDate')?.errors && form.get('endDate')?.touched">
                <span *ngIf="form.get('endDate')?.errors?.['required']">
                  {{ 'SELECT_END_DATE' | translate }}
                </span>

                <span *ngIf="form.get('endDate')?.errors?.['min']">
                  {{ 'END_DATE_BEFORE_START' | translate }}
                </span>

                <span *ngIf="form.get('endDate')?.errors?.['max']">
                  {{ 'END_DATE_FUTURE' | translate }}
                </span>
              </small>
            </div>

            <!-- Show Button -->
            <div class="col-sm-12">
              <!-- <button type="submit" class="show-button float-right" -->
              <button type="submit" class="trans_btns m_t_35" [ngClass]="{ 'backp_color': form.invalid || steddate }"
                [disabled]="form.invalid || steddate">
                {{'SHOW' | translate}}
              </button>
            </div>



            <div class="">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="limit" formControlName="limit" hidden>
                <input type="text" class="form-control" placeholder="index" formControlName="index" hidden>
              </div>
            </div>
          </div>
        </div>
        <div class="error fielderror fd m_l_10 m_t_10" *ngIf="steddate">{{ 'DATE_RANGE_INVALID' | translate }}</div>
      </form>
      <div *ngIf="remoteGameHistoryErrorMessage">
        <p class="errorTRA">
          {{remoteGameHistoryErrorMessage | translate}}
        </p>
      </div>
      <div class="cart-table-area fd bg_2 mt-2">
        <div class="d_grid" *ngIf="tableTrue">
          <div class="history-table-container">
            <table class="fd">
              <thead>
                <tr>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Game Name</th>
                  <th class="text-center">Initial Balance</th>
                  <th class="text-center">Bet</th>
                  <th class="text-center">Win</th>
                  <th class="text-center">Closing Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of remotehistoryList | paginate: { 
            itemsPerPage: itemsPerPage, 
            currentPage: p, 
            totalItems: totalItems 
          }">
                  <td>{{data.from}}</td>
                  <td>{{data.to}}</td>
                  <td>{{data.name}}</td>
                  <td class="text-center">{{data.initialBalance}}</td>
                  <td class="text-center">{{data.bet }}</td>
                  <td class="text-center">{{data.win }}</td>
                  <td class="text-center">{{data.closingBalance }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-footer">
            <select class="selt_bkp slct_wid" (change)="onChange($event)" [value]="itemsPerPage">
              <option *ngFor="let count of itemsperpagecount" [value]="count.num">
                {{ count.num }}
              </option>
            </select>

            <div class="table-footer m_t_0">
              <div class="pagination-container">
                <button (click)="p = p - 1" [disabled]="p === 1" class="pagination-btn">
                  &lsaquo; Previous
                </button>

                <span class="page-info">Page {{p}} of {{getTotalPages()}}</span>

                <button (click)="p = p + 1" [disabled]="p >= getTotalPages()" class="pagination-btn">
                  Next &rsaquo;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


